import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  receivedItems: {
    id: 'ASlPvx',
    defaultMessage: 'Received Items',
    description: 'Received Items header for Receiving Form',
  },
  showAdvancedFields: {
    id: 'srHB1i',
    defaultMessage: 'Show advanced inventory fields',
    description: 'Checkbox label to show advanced inventory fields like Lot ID and Expiration Date',
  },
});
